import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-plus",
  "use": "foquz-icon-plus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" id=\"foquz-icon-plus\"><path d=\"M0 7a1 1 0 011-1h12a1 1 0 110 2H1a1 1 0 01-1-1z\" fill=\"currentColor\" /><path d=\"M7 14a1 1 0 01-1-1V1a1 1 0 012 0v12a1 1 0 01-1 1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol